module.exports = __webpack_public_path__ + "static/fonts/DINProLight.19229af9.woff2";